import React, { Component } from 'react';
import './styles.scss';
import CategoryCard from '../CategoryCard';

export default class CategoryList extends Component {
  render() {
    return (
      <div className="category-list">
        <CategoryCard name="Штаны" img="https://images.ua.prom.st/1616027834_w640_h640_bryuki-muzhskie-yoshimitsu.jpg"/>
        <CategoryCard name="Худи" img="https://oxxxyshop.com/wa-data/public/shop/products/08/01/108/images/487/487.750@2x.jpg"/>
        <CategoryCard name="Ремни" img="https://kh-news.net/images/stories/main/remen/kak-pravilno-vybrat-remen-dlya-muzhchiny-foto2.jpg"/>
        <CategoryCard name="Футболки" img="https://miobi.eu/wp-content/uploads/m1134-e1500754613726.jpg"/>
        <CategoryCard name="Шорты" img="https://images.ua.prom.st/1136243793_w640_h640_molodezhnye-muzhskie-shorty.jpg"/>
        <CategoryCard name="Обувь" img="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRrUpYbDZYbKqx9kGvwJ1s_PE15ueHOM3Vi0q3U5q1q_XKI_eVayA&s"/>
      </div>
    );
  }
}
